// Excepciones de movilidad: cab por fuera de la policy (por ejemplo,
// pedido fuera de la ventana de 12 h). Relevamiento 2026-09-08: hoy Dow se
// entera al cierre de quien viajo con policy distinta; el contrato hace la
// excepcion autorizada, imputada a centro de costos y visible en tiempo real.
// Todavia sin ruta en la API (llega en R3): los schemas se publican en
// components para que mobile los conozca.
import { z } from "zod";
import { Instant, RecordId, SiteId } from "./common.js";
export const WaiverId = z.string().min(1).openapi("WaiverId", {
    description: "Identificador de una excepcion de movilidad.",
    example: "exc_000078",
});
export const WaiverStatus = z
    .enum(["pending", "approved", "rejected"])
    .openapi("WaiverStatus", {
    description: "Estado de la excepcion: pendiente de autorizacion, autorizada o rechazada.",
});
export const CreateWaiverRequest = z
    .object({
    siteId: SiteId,
    recordId: RecordId,
    reason: z.string().min(1).openapi({
        description: "Motivo declarado del pedido por fuera de la politica.",
        example: "Perdio la combi del turno de las 06:00",
    }),
    costCenter: z.string().min(1).openapi({
        description: "Centro de costos al que se imputa el viaje de excepcion. La imputacion en el momento (y no al cierre) es el valor central del flujo.",
        example: "CC-4310",
    }),
})
    .openapi("CreateWaiverRequest", {
    description: "Pedido de excepcion de movilidad (remis por fuera de la politica). Multi-tenant: siempre en el contexto de una planta (siteId).",
});
export const WaiverResponse = z
    .object({
    waiverId: WaiverId,
    siteId: SiteId,
    recordId: RecordId,
    reason: z.string().min(1),
    costCenter: z.string().min(1),
    status: WaiverStatus,
    resolvedBy: RecordId.optional().openapi({
        description: "Legajo de quien autorizo o rechazo la excepcion. Presente cuando el estado no es pending.",
    }),
    resolvedAt: Instant.optional().openapi({
        description: "Instante de la autorizacion o rechazo, en ISO 8601 UTC. Presente cuando el estado no es pending.",
    }),
})
    .openapi("WaiverResponse", {
    description: "Excepcion de movilidad con su estado y trazabilidad de quien la resolvio y cuando, visible en tiempo real para la planta.",
});
//# sourceMappingURL=exceptions.js.map